import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Calendar } from "lucide-react";
import Logo from "./Logo";
import { Button } from "./ui/button";

const NAV_LINKS = [
  { href: "#servicios", label: "Servicios" },
  { href: "#sobre-nosotros", label: "Sobre nosotros" },
  { href: "#galeria", label: "Galería" },
  { href: "#testimonios", label: "Testimonios" },
  { href: "#contacto", label: "Contacto" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // On non-home pages, hash links should route home first
  const isHome = location.pathname === "/";
  const resolveHref = (href) => (isHome ? href : `/${href}`);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "py-2" : "py-4"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <nav
          className={`flex items-center justify-between rounded-2xl px-4 py-2.5 transition-all duration-300 ${
            scrolled
              ? "glass shadow-[0_8px_30px_rgba(15,23,42,0.06)]"
              : "bg-white/0"
          }`}
        >
          <Logo />

          <div className="hidden items-center gap-1 md:flex">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={resolveHref(l.href)}
                data-testid={`nav-link-${l.href.replace("#", "")}`}
                className="rounded-full px-3.5 py-2 text-sm font-medium text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900"
              >
                {l.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-2">
            <Link to="/reserva" className="hidden sm:block">
              <Button
                data-testid="navbar-reservar-btn"
                className="rounded-full bg-[#1E3A8A] px-5 text-white shadow-sm hover:bg-[#172554]"
              >
                <Calendar className="mr-2 h-4 w-4" />
                Reservar hora
              </Button>
            </Link>
            <button
              type="button"
              aria-label="Menu"
              data-testid="mobile-menu-toggle"
              onClick={() => setOpen((v) => !v)}
              className="grid h-10 w-10 place-items-center rounded-full border border-slate-200 bg-white md:hidden"
            >
              {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          </div>
        </nav>

        {open && (
          <div
            data-testid="mobile-menu"
            className="mt-2 rounded-2xl glass p-3 md:hidden"
          >
            <div className="flex flex-col">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.href}
                  href={resolveHref(l.href)}
                  onClick={() => setOpen(false)}
                  className="rounded-xl px-3 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-100"
                >
                  {l.label}
                </a>
              ))}
              <Link to="/reserva" onClick={() => setOpen(false)} className="mt-1">
                <Button className="w-full rounded-full bg-[#1E3A8A] text-white">
                  <Calendar className="mr-2 h-4 w-4" />
                  Reservar hora
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
